/**
  * @typedef {Object} Breakpoint
  * @param {number} min
  * @param {number} max
  * @param {string} name
  * @param {number} order
  */

/** @enum {Breakpoint} */
export const Breakpoints = {
  xs: { min:   0, max: 575, name: 'xs', order: 1 }, // Extra small devices (portrait phones, less than 576px)
  sm: { min: 576, max: 767, name: 'sm', order: 2 } , // Small devices (landscape phones, 576px and up)
  md: { min: 768, max: 991, name: 'md', order: 3 }, // Medium devices (tablets, 768px and up)
  lg: { min: 992, max: 1199, name: 'lg', order: 4 }, // Large devices (desktops, 992px and up)
  xl: { min: 1200, max: Number.POSITIVE_INFINITY, name: 'xl', order: 5 }, // Extra large devices (large desktops, 1200px and up)
};
